export enum BestellungStatus {
  Kritisch = 'Kritisch',
  Unbearbeitet = 'Unbearbeitet',
  InBearbeitung = 'InBearbeitung',
  Abgeschlossen = 'Abgeschlossen',
  Fertig = 'Fertig',
}